import { palette } from 'src/styles/colors';
import { StyledContainerWithScale } from 'src/styles/functions/getAnimationContainerDefaultStyles';
import { layout } from 'src/styles/layout';
import styled, { css } from 'styled-components';

interface FooterContainerProps {
  isFullScreen?: boolean;
}

export const FooterContainer = styled.div<FooterContainerProps>`
  max-width: 100vw !important;
  background-color: ${palette.greyText};
  display: grid;
  position: relative;

  ${(props) =>
    !props.isFullScreen
      ? ''
      : css`
          width: 100vw;
        `}
`;

export const FooterGridContainer = styled.div`
  width: 100%;
  position: relative;
  display: grid;
  top: -2px; // Pull background up to avoid white line
  z-index: 2;
`;

export const FooterGridWrapper = styled(StyledContainerWithScale)`
  padding: 5.875rem 5.125rem 0rem;
  box-sizing: border-box;
  max-width: 1440px;
  margin: 0 auto;
  transform-origin: bottom;
  width: 100%;
  align-self: end;

  @media screen and (max-width: ${layout.sm}) {
    padding-bottom: 2rem;
  }
`;

export const BottomBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  height: 100%;
  transform-origin: bottom;
  z-index: 1;
`;

export const PoliciesLinkWrapper = styled(StyledContainerWithScale)`
  padding-bottom: 1.8rem;
  box-sizing: border-box;
  margin-top: 380px; // Space between links and footer bottom, since the logo is absolutely positioned
  transform-origin: bottom;

  @media screen and (max-width: 2000px) {
    margin-top: 232px;
  }

  @media screen and (max-width: 1360px) {
    margin-top: 150px;
  }

  @media screen and (max-width: ${layout.sm}) {
    margin-top: 130px;
  }
`;

export const LogoContainer = styled(StyledContainerWithScale)`
  position: absolute;
  left: 50%;
  bottom: 50%;
  transform: translate(-50%, 50%) scale(${(props) => props.currentScale ?? 1});
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  @media screen and (max-width: ${layout.sm}) {
    transform: translate(-50%, 30%) scale(${(props) => props.currentScale ?? 1});
  }
`;
